/**************************************************
 * Nombre:       Tarjeta_Personas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";


const Tarjeta_Personas = ({item}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <img src={item.img} width={'100%'} height={'auto'} alt={'auto'} style={{borderRadius: 12}}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2}}>
                <Typography sx={{color: theme.palette.primary.main, fontWeight: 600, fontSize: sCell ? 14 : 16}}>
                    {item.nombre}
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <Typography sx={{fontSize: sCell ? 12 : 14}}>{item.profesion} </Typography>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Personas    